import React, { useState, forwardRef } from "react";
import { Input } from "../ui/input";
import { selectOnFocus, parseNum } from "../../lib/inputHelpers";

// v6 E6 — shared raw numeric input with draft state + comma/dot decimals.
// Use for any controlled numeric field where the parent stores the parsed Number.
// During typing the input keeps the RAW string the user typed (so '3,75' stays
// visible as the user types it). onBlur reverts to the controlled parsed value.
// Parent always receives a normalized Number via parseNum.
//
// Props:
//   value:        current parsed number (Number | null | "")
//   onChange:     called with parsed Number (or "" if allowEmpty && raw is "")
//   allowEmpty:   pass through "" to parent so unit_price_override etc. can be null
//   inputMode:    "decimal" (default) or "numeric"
//   ...rest:      forwarded to <Input> (className, placeholder, data-testid, disabled, ...)
const RawNumInput = forwardRef(function RawNumInput(
  { value, onChange, allowEmpty = false, inputMode = "decimal", ...rest },
  ref
) {
  const [draft, setDraft] = useState(null);
  const display = draft !== null
    ? draft
    : (value === null || value === undefined ? "" : value);
  return (
    <Input
      ref={ref}
      type="text"
      inputMode={inputMode}
      pattern={inputMode === "numeric" ? "[0-9]*" : "[0-9.,]*"}
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      value={display}
      onFocus={(ev) => { setDraft(value === null || value === undefined ? "" : String(value)); selectOnFocus(ev); }}
      onChange={(ev) => {
        const raw = ev.target.value;
        setDraft(raw);
        if (allowEmpty && raw === "") return onChange("");
        onChange(parseNum(raw));
      }}
      onBlur={() => setDraft(null)}
      {...rest}
    />
  );
});

export default RawNumInput;
